/* eslint-disable */
export default {
  title: 'History',
} as const;

// @key: @#@"title"@#@ @source: @#@"History"@#@
